import { createSlice } from "@reduxjs/toolkit";

const printRequestsSlice = createSlice({
  name: "printRequests",
  initialState: {
    list: [], // All print requests (PENDING, ACCEPTED, etc.)
    // removed: completed, rejected (we now fetch those on-demand)
  },
  reducers: {
    setRequests(state, action) {
      state.list = action.payload;
    },
    addRequest(state, action) {
      const existingIndex = state.list.findIndex(
        (request) => request.id === action.payload.id
      );
      if (existingIndex !== -1) {
        state.list[existingIndex] = action.payload;
      } else {
        state.list.push(action.payload);
      }
    },
    removeRequest(state, action) {
      state.list = state.list.filter((request) => request.id !== action.payload);
    },
    clearRequests(state) {
      state.list = [];
    },
    updateRequestStatus(state, action) {
      const { id, status } = action.payload;
      const idx = state.list.findIndex((r) => r.id === id);
      if (idx !== -1) {
        state.list[idx].status = status;
        state.list[idx].updatedAt = new Date().toISOString();

        // keep list consistent (we don't persist completed/rejected arrays here)
        // If you want to remove the item from the list when it becomes COMPLETED/REJECTED:
        if (status === "COMPLETED" || status === "REJECTED") {
          state.list.splice(idx, 1);
        }
      }
    },
    replaceRequest(state, action) {
      const updated = action.payload;
      const idx = state.list.findIndex((r) => r.id === updated.id);
      if (idx !== -1) {
        state.list[idx] = updated;
      }
    },
  },
});

export const {
  setRequests,
  addRequest,
  removeRequest,
  clearRequests,
  updateRequestStatus,
  replaceRequest,
} = printRequestsSlice.actions;

export default printRequestsSlice.reducer;
